import "./StatusBar.css";

/*
  StatusBar.jsx — Status message and progress display

  Shows the user what's happening:
  - Idle: nothing shown
  - Loading with percent: progress bar + message
  - Loading without percent: spinner + message
  - Done/error: plain message
*/

export default function StatusBar({ message, loading, percent }) {
  if (!message && !loading) return null;

  const showProgress = loading && percent !== null && percent !== undefined;

  return (
    <div className={`status-bar ${loading ? "status-bar--loading" : ""}`}>
      {/* Progress bar — shown when we have a real percentage */}
      {showProgress && (
        <div className="status-progress-wrap">
          <div
            className="status-progress-bar"
            style={{ width: `${percent}%` }}
          />
        </div>
      )}

      <div className="status-row">
        {/* Spinner — shown when loading but no percentage yet */}
        {loading && !showProgress && <span className="status-spinner" />}
        <span className="status-message">{message}</span>
        {showProgress && (
          <span className="status-percent">{percent}%</span>
        )}
      </div>
    </div>
  );
}
